import Vue from 'vue';
import App from './App.vue';
import router from './router';
import './assets/scss/style.scss';
import VueAnalytics from 'vue-analytics';
import VuePageTransition from 'vue-page-transition'

Vue.use(VuePageTransition)

Vue.config.productionTip = false;

// Configuration VueAnalytics
Vue.use(VueAnalytics, {
  id: 'UA-76177257-4',
  router
});

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
